export default __webpack_public_path__ + "static/media/SharpGrotesk.83d164ab.woff";